var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicinebox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 594,
    height: 594,
    viewBox: "0 0 594 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 296.975,
    cy: 296.974,
    r: 296.824,
    transform: "rotate(-0.0291588 296.975 296.974)",
    fill: "#916ede"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4508_116094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.497 165.273V183.854L193.35 192.854L245.203 183.854V165.273L193.35 156.273L141.497 165.273Z",
    fill: "#A71F29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.203 183.855H141.497V197.088L193.35 206.088L245.203 197.088V183.855Z",
    fill: "#C32430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.866 146.693V134.7C254.866 131.849 252.555 129.539 249.705 129.539H136.996C134.146 129.539 131.835 131.85 131.835 134.7V146.692L193.351 155.692L254.866 146.693Z",
    fill: "#DA4A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.996 165.272H249.705C252.556 165.272 254.866 162.961 254.866 160.111V146.691H131.835V160.11C131.835 162.961 134.145 165.272 136.996 165.272Z",
    fill: "#D82E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.248 276.951V97.484C465.248 88.932 458.315 82 449.764 82H302.127C293.576 82 286.643 88.932 286.643 97.484V276.951L375.945 285.951L465.248 276.951Z",
    fill: "#EDF4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.643 295.53L375.946 304.53L465.248 295.53V276.949H286.643V295.53Z",
    fill: "#D8E5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.288 159.288C422.695 159.288 431.131 150.851 431.131 140.445C431.131 130.038 422.695 121.602 412.288 121.602C401.881 121.602 393.445 130.038 393.445 140.445C393.445 150.851 401.881 159.288 412.288 159.288Z",
    fill: "#D4A8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.288 227.409C422.695 227.409 431.131 218.972 431.131 208.566C431.131 198.159 422.695 189.723 412.288 189.723C401.881 189.723 393.445 198.159 393.445 208.566C393.445 218.972 401.881 227.409 412.288 227.409Z",
    fill: "#D4A8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.603 159.288C350.01 159.288 358.446 150.851 358.446 140.445C358.446 130.038 350.01 121.602 339.603 121.602C329.196 121.602 320.76 130.038 320.76 140.445C320.76 150.851 329.196 159.288 339.603 159.288Z",
    fill: "#D4A8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.603 227.409C350.01 227.409 358.446 218.972 358.446 208.566C358.446 198.159 350.01 189.723 339.603 189.723C329.196 189.723 320.76 198.159 320.76 208.566C320.76 218.972 329.196 227.409 339.603 227.409Z",
    fill: "#D4A8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.203 276.95V197.086H141.497V276.95L193.35 285.95L245.203 276.95Z",
    fill: "#D4A8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.497 295.53L193.35 304.53L245.203 295.53V276.949H141.497V295.53Z",
    fill: "#DFC1FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.625 276.95V240.665C205.625 237.814 203.314 235.504 200.464 235.504H141.497V276.95L173.561 285.95L205.625 276.95Z",
    fill: "#EDF4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.497 295.53L173.561 304.53L205.625 295.53V276.949H141.497V295.53Z",
    fill: "#D8E5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.432 276.953C358.433 276.865 358.445 276.779 358.445 276.691C358.445 266.284 350.009 257.848 339.602 257.848C329.195 257.848 320.759 266.284 320.759 276.691C320.759 276.779 320.771 276.865 320.772 276.953L339.602 285.953L358.432 276.953Z",
    fill: "#845EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.773 276.949C320.915 287.233 329.285 295.53 339.603 295.53C349.921 295.53 358.291 287.234 358.433 276.949H320.773Z",
    fill: "#D4A8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.957 578.515C119.957 587.066 126.889 593.999 135.441 593.999H470.559C479.11 593.999 486.043 587.067 486.043 578.515V424.836L303 415.836L119.957 424.836V578.515Z",
    fill: "#E4936B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.957 406.254V424.835H486.043V406.254L303 397.254L119.957 406.254Z",
    fill: "#DB835D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.955 387.676L83.882 399.402C82.717 402.756 85.208 406.257 88.758 406.257H517.242C520.792 406.257 523.282 402.756 522.118 399.402L518.045 387.676L303 378.676L87.955 387.676Z",
    fill: "#F9C6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.045 387.674L487.247 298.999C486.526 296.923 484.569 295.531 482.371 295.531H123.628C121.43 295.531 119.474 296.923 118.752 298.999L87.9539 387.675H518.045V387.674Z",
    fill: "#FFD6BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.118 276.953C431.119 276.865 431.131 276.779 431.131 276.691C431.131 266.284 422.695 257.848 412.288 257.848C401.881 257.848 393.445 266.284 393.445 276.691C393.445 276.779 393.457 276.865 393.458 276.953L412.288 285.953L431.118 276.953Z",
    fill: "#845EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.459 276.949C393.601 287.233 401.971 295.53 412.289 295.53C422.607 295.53 430.977 287.234 431.119 276.949H393.459Z",
    fill: "#D4A8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.691 516.455H441.519C445.804 516.455 449.276 512.982 449.276 508.698C449.276 504.414 445.803 500.941 441.519 500.941H388.691C384.407 500.941 380.934 504.414 380.934 508.698C380.934 512.982 384.406 516.455 388.691 516.455Z",
    fill: "#EDF4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.691 550.811H441.519C445.804 550.811 449.276 547.339 449.276 543.054C449.276 538.769 445.803 535.297 441.519 535.297H388.691C384.407 535.297 380.934 538.77 380.934 543.054C380.934 547.338 384.406 550.811 388.691 550.811Z",
    fill: "#EDF4FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4508_116094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(47 82)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicinebox);
export default __webpack_public_path__ + "static/media/medicinebox.1ebef66af01c91b78b84d6266d12f1c9.svg";
export { ForwardRef as ReactComponent };